import React from 'react';

const ProgressBar = ({ 
  progress, 
  gradient = 'from-blue-500 to-indigo-500',
  height = 'h-2',
  showPercentage = true,
  label = '',
  className = ''
}) => {
  const percentage = Math.min(Math.max(progress, 0), 100);

  return (
    <div className={`w-full ${className}`}>
      {(label || showPercentage) && (
        <div className="flex justify-between text-sm text-gray-600 mb-2">
          <span>{label}</span>
          {showPercentage && <span className="font-semibold">{Math.round(percentage)}%</span>}
        </div>
      )}
      <div className={`w-full bg-gray-200 rounded-full ${height} overflow-hidden`}>
        <div 
          className={`bg-gradient-to-r ${gradient} ${height} rounded-full transition-all duration-500 ease-out relative`}
          style={{ width: `${percentage}%` }}
        >
          <div className="absolute right-0 top-0 h-full w-1 bg-white/30 rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;